import { Button } from "@mui/material";
import { FieldError } from "react-hook-form";
import Label from "../../components/form/Label";
import MyCheckBox from "../../components/formFields/MyCheckBox";
import { CityAutocomplete } from "../../components/formFields/Mycity";
import { MyCreateSelect } from "../../components/formFields/MyCreateSelect";
import MyDatePicker from "../../components/formFields/MyDatePicker";
import MyEditor from "../../components/formFields/MyEditor";
import MyFileUpload from "../../components/formFields/MyFileUpload";
import { MyInput } from "../../components/formFields/MyInput";
import { MyMultiSelect } from "../../components/formFields/MyMutiSelect";
import { MySearch } from "../../components/formFields/MySearch";
import MySection from "../../components/formFields/MySection";
import { MySelect } from "../../components/formFields/MySelect";
import { StateAutocomplete } from "../../components/formFields/Mystate";
import { MyTextArea } from "../../components/formFields/MyTextArea";
import Years from "../../components/formFields/MyYears";
import LocationAutoComplete from "../components/LocationAutoComplete/LocationAutoComplete";
import MuiTimePicker from "../../components/formFields/MyTimePicker";
import { MyCreateSelectSearch } from "../../components/formFields/MyCreateSelectSearch";
import { LocationDropdown } from "../../components/formFields/MyLocation";
import { useData } from "../../context/GetDataContext";
import { useEffect, useRef, useState } from "react";
import DispatchTable from "../../components/Load/DispatchTable";
import { useAxios } from "../../utils/useAxios";
import MyCheckBoxBoolean from "../../components/formFields/MyCheckBoxBoolean";

type SectionDrawerProps = {
  sectionsMerge: any;
  formData: any;
  isEditMode?: any;
  setModalContent?: any;
  setModalHeader?: any;
  setModalOpen?: any;
  setPopFromId?: any;
  openModal?: any;
  formId?: any;
};

export const SectionDrawer = ({
  sectionsMerge,
  formData,
  isEditMode = false,
  setModalContent = () => false,
  setModalHeader = () => false,
  setModalOpen = () => false,
  setPopFromId = () => false,
  openModal = () => false,
  formId,
}: SectionDrawerProps) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
    watch,
  } = formData;

  const [driverData, setDriverData] = useState();

  const prevDriverId = useRef(null);
  const prevVehicleId = useRef(null);
  const prevTrailerId = useRef(null);

  const { res, mutate, isPending } = useAxios({
    url: "/api/auth/driverhistory",
    onSuccess: (res) => {
      setDriverData(res);
    },
  });

  const { data } = useData();

  const watched = watch();
  useEffect(() => {
    const driverId = watched?.["driver_id"];
    const vehicleId = watched?.["vehicle_id"];
    const trailerId = watched?.["trailer_id"];

    if (formId === "LoadDispatch" && data) {
      if (driverId && driverId !== prevDriverId.current) {
        mutate({
          table: "drivers",
          type: "driver",
          id: driverId,
          load_id: data.id,
          delivery_date: data.delivery_date,
          pickup_date: data.pick_up_date,
        });
        prevDriverId.current = driverId;
      }

      if (vehicleId && vehicleId !== prevVehicleId.current) {
        mutate({
          table: "vehicle",
          type: "vehicle",
          id: vehicleId,
          load_id: data.id,
          delivery_date: data.delivery_date,
          pickup_date: data.pick_up_date,
        });
        prevVehicleId.current = vehicleId;
      }

      if (trailerId && trailerId !== prevTrailerId.current) {
        mutate({
          table: "trailer",
          type: "trailer",
          id: trailerId,
          load_id: data.id,
          delivery_date: data.delivery_date,
          pickup_date: data.pick_up_date,
        });
        prevTrailerId.current = trailerId;
      }
    }
  }, [
    watched?.["driver_id"],
    watched?.["vehicle_id"],
    watched?.["trailer_id"],
    data?.id,
    formId,
  ]);

  return (
    <>
      <div className="row">
        {sectionsMerge.map((section: any, index: any) => (
          <div key={index} className={`mb-5 ${section?.colsize}`}>
            <MySection
              title={`${section?.sectionid ? section?.title : ""}`}
              sectionShow={section?.sectionid ? section.title : ""}
              tab={section?.tab}
            >
              <div className={`row px-3`}>
                {section?.columns?.map((formfield: any, findex: any) => {
                  const {
                    title,
                    field,
                    component,
                    placeholder,
                    options,
                    type,
                    info,
                    required,
                    show_class,
                    searching_key,
                    display_searching_key,
                    colsize,
                    depend_key,
                    depend_key_name,
                  } = formfield as any;

                  const isMandatory = required === 1;
                  let isMan_manual = false;

                  if (
                    field === "drop_empty_tailer_id" &&
                    data?.pick_up_stop_pickup === "Live Load"
                  ) {
                    return null;
                  }

                  if (
                    field === "pick_empty_tailer_id" &&
                    data?.delivery_stop_delivery === "Live Unload"
                  ) {
                    return null;
                  }

                  if (show_class) {
                    // console.log(show_class);
                    const targetValue = watched?.[show_class.field];
                    if (targetValue === show_class.value) {
                      isMan_manual = true;
                    } else if (targetValue !== show_class.value) {
                      if (
                        [
                          "pick_up_endtime",
                          "pick_up_starttime",
                          "delivery_start_time",
                          "delivery_end_time",
                        ].includes(field)
                      ) {
                        {
                        } // Do not render this field
                      } else {
                        return null; // Do not render this field
                      }
                    }

                    // {...register("pick_up_time", {
                    //       required:
                    //         watched?.pick_up_appt === "YES"
                    //           ? "Pick up time is required"
                    //           : false,
                    //     })}
                  }

                  const renderLabel = (includeInfo = false) => (
                    <Label className=" ">
                      {title}
                      {isMandatory && <span className="text-red-500"> *</span>}
                      {includeInfo && info && (
                        <button
                          onClick={() => {
                            setModalContent(info);
                            setModalHeader(title);
                            setModalOpen(true);
                          }}
                          className="ml-2 text-xs text-white bg-indigo-500 hover:bg-indigo-800 px-2 py-0.5 rounded"
                          type="button"
                        >
                          <i className="fa fa-info"></i>
                        </button>
                      )}
                    </Label>
                  );

                  const commonProps = {
                    name: field,
                    control,
                    register,
                    setValue,
                    error: errors[field] as FieldError | undefined,
                    disabled: isEditMode,
                    searching_key: searching_key,
                    display_searching_key: display_searching_key,
                    ...(isEditMode && {
                      selected: watched[field],
                    }),

                    ...(isMandatory && {
                      validationRules: { required: `${title} is required` },
                    }),
                  };

                  const fieldComponents: Record<string, JSX.Element> = {
                    input: (
                      <>
                        {renderLabel()}
                        <MyInput
                          {...commonProps}
                          placeholder={placeholder}
                          type={type}
                        />
                      </>
                    ),
                    location: (
                      <>
                        {renderLabel()}
                        <LocationAutoComplete
                          {...commonProps}
                          onSelect={({ lat, lng }) =>
                            setValue(field, [lat, lng])
                          }
                          setValue={setValue}
                        />
                      </>
                    ),
                    select: (
                      <>
                        {renderLabel(true)}
                        <MySelect
                          {...commonProps}
                          options={options || []}
                          type={type}
                          control={control}
                          depend_key={depend_key}
                          depend_key_name={depend_key_name}
                        />
                      </>
                    ),
                    my_create_select_search: (
                      <>
                        {renderLabel()}

                        <MyCreateSelectSearch
                          {...commonProps}
                          labelKey={field}
                          valueKey={type}
                          setValue={setValue}
                          createName={section?.title}
                          depend_key_name={depend_key_name}
                          options_list={options || []}
                          watch={watch}
                          control={control}
                        />
                        {/* {console.log(depend_key_name)} */}
                        {![
                          "drop_empty_tailer_id",
                          "pick_empty_tailer_id",
                        ].includes(field) && (
                          <Button
                            onClick={() => {
                              let formids = field;
                              if (field === "driver_id") {
                                formids = "drivers";
                              }
                              if (field === "trailer_id") {
                                formids = "trailer";
                              }
                              if (field === "vehicle_id") {
                                formids = "vehicle";
                              }
                              setPopFromId(formids);
                              openModal();
                            }}
                            sx={{
                              p: 0,
                              textTransform: "capitalize",
                              fontSize: "0.8rem",
                            }}
                          >
                            New Create
                          </Button>
                        )}
                      </>
                    ),
                    g_location: (
                      <>
                        {renderLabel()}
                        <LocationDropdown
                          {...commonProps}
                          placeholder={placeholder}
                        />
                      </>
                    ),
                    mycity: (
                      <>
                        {renderLabel()}
                        <CityAutocomplete {...commonProps} />
                      </>
                    ),
                    mystate: (
                      <>
                        {renderLabel()}
                        <StateAutocomplete {...commonProps} />
                      </>
                    ),
                    mycreateselect: (
                      <>
                        {renderLabel()}
                        <MyCreateSelect
                          {...commonProps}
                          labelKey={field}
                          valueKey={type}
                          setValue={setValue}
                          createName={section?.title}
                        />
                        <Button
                          onClick={() => {
                            setPopFromId(field);
                            openModal();
                          }}
                          sx={{
                            p: 0,
                            textTransform: "capitalize",
                            fontSize: "0.8rem",
                          }}
                        >
                          New Create
                        </Button>
                      </>
                    ),
                    search: (
                      <>
                        {renderLabel()}
                        <MySearch
                          {...commonProps}
                          labelKey={field}
                          valueKey={type}
                          setValue={setValue}
                          createName={section?.title}
                        />
                      </>
                    ),
                    select_search: (
                      <>
                        {renderLabel()}
                        <MyCreateSelect
                          {...commonProps}
                          labelKey={field}
                          valueKey={type}
                          setValue={setValue}
                          createName={section?.title}
                        />
                      </>
                    ),
                    years: (
                      <>
                        {renderLabel(true)}
                        <Years {...commonProps} type={type} />
                      </>
                    ),
                    "select-multi": (
                      <>
                        {renderLabel()}
                        <MyMultiSelect
                          {...commonProps}
                          setValue={setValue}
                          options={options || []}
                          type={type}
                        />
                      </>
                    ),
                    textarea: (
                      <>
                        {renderLabel()}
                        <MyTextArea
                          {...commonProps}
                          placeholder={placeholder}
                        />
                      </>
                    ),
                    checkbox: (
                      <div className="items-center">
                        {renderLabel()}

                        <MyCheckBox {...commonProps} control={control} />
                      </div>
                    ),
                    boolean_checkbox: (
                      <div className="items-center">
                        {renderLabel()}
                        <MyCheckBoxBoolean {...commonProps} control={control} />
                      </div>
                    ),
                    datepicker: (
                      <>
                        {renderLabel()}
                        <MyDatePicker
                          name={field}
                          control={control}
                          disabled={isEditMode}
                        />
                      </>
                    ),
                    datepickerrange: (
                      <>
                        {renderLabel()}
                        <MyDatePicker
                          name={field}
                          control={control}
                          disabled={isEditMode}
                        />
                      </>
                    ),
                    timepicker: (
                      <>
                        {renderLabel()}
                        <MuiTimePicker
                          {...commonProps}
                          placeholder={placeholder}
                          type={type}
                          validationRules={
                            isMan_manual
                              ? { required: `${title} is required` }
                              : {}
                          }
                        />
                      </>
                    ),
                    fileupload: (
                      <>
                        {renderLabel()}
                        <MyFileUpload
                          {...commonProps}
                          label="Upload Documents"
                          required
                          multiple
                          maxSize={10}
                        />
                      </>
                    ),
                    myeditor: (
                      <>
                        {renderLabel()}
                        <MyEditor {...commonProps} type={type} />
                      </>
                    ),
                    "geo-input": (
                      <>
                        {renderLabel()}
                        {/* <MyGeoInput
                            {...commonProps}
                            getCoordinates={[
                              {
                                latitude:
                                  watched?.delivery_stop_delivery?.coordinates
                                    ?.latitude,
                                longitude:
                                  watched?.delivery_stop_delivery?.coordinates
                                    ?.longitude,
                              },
                              {
                                latitude:
                                  watched?.pick_up_stop_pickup?.coordinates
                                    .latitude,
                                longitude:
                                  watched?.pick_up_stop_pickup?.coordinates
                                    .longitude,
                              },
                            ]}
                            placeholder={placeholder}
                            type={type}
                          /> */}
                      </>
                    ),
                  };

                  return (
                    <div
                      key={`${field}-${findex}`}
                      className={`${colsize} mb-2`}
                      style={{
                        paddingLeft: "0.20rem",
                        paddingRight: "0.20rem",
                      }}
                    >
                      {fieldComponents[component] ?? <></>}
                    </div>
                  );
                })}
              </div>
            </MySection>
          </div>
        ))}
      </div>
      {formId === "LoadDispatch" && driverData && (
        <DispatchTable driverData={driverData} />
      )}
    </>
  );
};
